export default __webpack_public_path__ + "static/test_tom-37649ce8579b383a4fd5a27096b042d6.png";